import { render, staticRenderFns } from "./MineType.vue?vue&type=template&id=02b024c4&scoped=true"
import script from "./MineType.vue?vue&type=script&lang=js"
export * from "./MineType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b024c4",
  null
  
)

export default component.exports